import styled from 'styled-components';

import { GameplayTier } from '#src/__generated__/globalTypes.ts';
import { Star } from '#src/atoms/icons/Star.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { Stars } from '#src/components/card/StarRank/Stars/index.tsx';
import { range } from '#src/lib/arrays.ts';
import { GAMEPLAY_TIER_LABELS } from '#src/lib/gameplayTiers.ts';
import type { Unit } from '#src/lib/style.ts';

const FlatRoot = styled(Horizontal).attrs({ as: 'span', center: true, gap: 0 })`
  display: inline-flex;
`;

const convertTierToNumberOfStars = (gameplayTier: GameplayTier) => {
  return {
    [GameplayTier.GOAT]: 5,
    [GameplayTier.STAR]: 4,
    [GameplayTier.IMPACT]: 3,
    [GameplayTier.ROSTER]: 2,
    [GameplayTier.DNP]: 1,
  }[gameplayTier];
};

export type GameplayTierStarsVariant = 'default' | 'flat';

type GameplayTierStarsProps = {
  gameplayTier: GameplayTier;
  size?: Unit;
  variant?: GameplayTierStarsVariant;
};

export const GameplayTierStars = ({
  gameplayTier,
  size = 1,
  variant = 'default',
}: GameplayTierStarsProps) => {
  const nbStars = convertTierToNumberOfStars(gameplayTier);
  const accessibilityLabel = GAMEPLAY_TIER_LABELS[gameplayTier];

  if (variant === 'flat') {
    return (
      <FlatRoot>
        {range(nbStars).map(i => (
          <Star key={i} size={size} role="img" />
        ))}
        <span className="sr-only">{accessibilityLabel}</span>
      </FlatRoot>
    );
  }

  return (
    <Stars
      count={nbStars}
      size={size}
      sparkles={GameplayTier.GOAT === gameplayTier}
    >
      <span className="sr-only">{accessibilityLabel}</span>
    </Stars>
  );
};
